/*
 * Herramientas gratis de Beluga Fitness: calculadoras y quiz.
 *
 * Cada herramienta es un <div data-tool="..."> pintado por snippets/tool-*.liquid. Aqui
 * se busca ese atributo y se monta la logica que le toca. Todo corre en el navegador: no se
 * manda ningun dato a ningun servidor. Lo unico que se guarda es un "perfil" local (sexo,
 * edad, estatura, peso) para que al pasar de una calculadora a otra no haya que reescribirlo.
 *
 * Analitica: un solo evento `tool_used` por pagina, la primera vez que la herramienta da un
 * resultado. Va directo a `belugaGtag` y a Clarity, igual que los demas eventos de
 * comportamiento del tema (ver `_ga4` en app.js); no toca el embudo de compra.
 */
(function () {
  'use strict';

  // ── Utilidades ─────────────────────────────────────────────────────────
  var PROFILE_KEY = 'beluga_tools_profile';
  var PROFILE_FIELDS = ['sex', 'age', 'height', 'weight'];

  function num(v) {
    if (v === null || v === undefined || v === '') return NaN;
    var n = parseFloat(String(v).replace(',', '.'));
    return isFinite(n) ? n : NaN;
  }

  function inRange(n, min, max) {
    return isFinite(n) && n >= min && n <= max;
  }

  function clamp(n, min, max) {
    return Math.min(Math.max(n, min), max);
  }

  function fmt(n, decimals) {
    var d = decimals || 0;
    return Number(n).toLocaleString('es-MX', { minimumFractionDigits: d, maximumFractionDigits: d });
  }

  // Quita los ceros sobrantes: 22.5 → "22.5", 20 → "20".
  function fmtTrim(n, maxDecimals) {
    return Number(n).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: maxDecimals === undefined ? 2 : maxDecimals });
  }

  function money(n) {
    return Number(n).toLocaleString('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: n >= 1000 ? 0 : 2, maximumFractionDigits: n >= 1000 ? 0 : 2 });
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formValues(form) {
    var out = {};
    new FormData(form).forEach(function (v, k) { out[k] = v; });
    return out;
  }

  function timeToMinutes(t) {
    if (!t || !/^\d{1,2}:\d{2}$/.test(t)) return NaN;
    var p = t.split(':');
    return parseInt(p[0], 10) * 60 + parseInt(p[1], 10);
  }

  function minutesToTime(m) {
    var mm = ((Math.round(m) % 1440) + 1440) % 1440;
    var h = Math.floor(mm / 60);
    var mi = mm % 60;
    return (h < 10 ? '0' : '') + h + ':' + (mi < 10 ? '0' : '') + mi;
  }

  function readProfile() {
    try { return JSON.parse(localStorage.getItem(PROFILE_KEY)) || {}; } catch (e) { return {}; }
  }

  function saveProfile(form) {
    try {
      var profile = readProfile();
      var values = formValues(form);
      PROFILE_FIELDS.forEach(function (f) {
        if (!(f in values)) return;
        if (values[f] === '') return;
        profile[f] = values[f];
      });
      localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
    } catch (e) { /* modo privado o almacenamiento bloqueado: la herramienta sigue funcionando */ }
  }

  function applyProfile(form) {
    var profile = readProfile();
    PROFILE_FIELDS.forEach(function (f) {
      if (profile[f] === undefined) return;
      var fields = form.querySelectorAll('[name="' + f + '"]');
      if (!fields.length) return;
      if (fields[0].type === 'radio') {
        fields.forEach(function (r) { r.checked = r.value === profile[f]; });
      } else if (fields[0].value === '') {
        fields[0].value = profile[f];
      }
    });
  }

  var tracked = false;
  function track(tool, extra) {
    if (tracked) return;
    tracked = true;
    var params = { tool_name: tool };
    if (extra) Object.keys(extra).forEach(function (k) { params[k] = extra[k]; });
    try {
      if (typeof window.belugaGtag === 'function') window.belugaGtag('event', 'tool_used', params);
      if (typeof window.clarity === 'function') {
        window.clarity('event', 'tool_used');
        window.clarity('set', 'herramienta', tool);
      }
      document.dispatchEvent(new CustomEvent('beluga:tool_used', { detail: params }));
    } catch (e) { /* silencioso */ }
  }

  // ── Piezas de HTML para los resultados ─────────────────────────────────
  function stat(label, value, unit, sub) {
    return '<div class="bt-stat"><div class="bt-stat-label">' + label + '</div>' +
      '<div class="bt-stat-value">' + value + (unit ? '<small>' + unit + '</small>' : '') + '</div>' +
      (sub ? '<div class="bt-stat-sub">' + sub + '</div>' : '') + '</div>';
  }

  function kpi(label, value, unit, dot) {
    return '<div class="bt-kpi"><div class="bt-kpi-label">' +
      (dot ? '<span class="bt-dot" style="background:' + dot + '"></span>' : '') + label + '</div>' +
      '<div class="bt-kpi-value">' + value + (unit ? '<small>' + unit + '</small>' : '') + '</div></div>';
  }

  function kpis(items, three) {
    return '<div class="bt-kpis' + (three ? ' bt-kpis--3' : '') + '">' + items.join('') + '</div>';
  }

  function note(html, warn) {
    return '<p class="bt-note' + (warn ? ' bt-note--warn' : '') + '">' + html + '</p>';
  }

  function badge(text, kind) {
    return '<span class="bt-badge bt-badge--' + kind + '">' + text + '</span>';
  }

  function list(rows) {
    return '<ul class="bt-list">' + rows.map(function (r) {
      return '<li><span>' + r[0] + '</span><strong>' + r[1] + '</strong></li>';
    }).join('') + '</ul>';
  }

  // Medidor con tramos de color y un marcador. segments: [[desde, hasta, color, etiqueta]]
  function gauge(segments, value) {
    var min = segments[0][0];
    var max = segments[segments.length - 1][1];
    var span = max - min;
    var pos = clamp((value - min) / span * 100, 0, 100);
    var track = segments.map(function (s) {
      return '<span style="width:' + ((s[1] - s[0]) / span * 100) + '%;background:' + s[2] + '"></span>';
    }).join('');
    var labels = segments.map(function (s) {
      return '<span style="width:' + ((s[1] - s[0]) / span * 100) + '%">' + (s[3] || '') + '</span>';
    }).join('');
    return '<div class="bt-gauge"><div class="bt-gauge-track">' + track + '</div>' +
      '<span class="bt-gauge-marker" style="left:' + pos + '%"></span>' +
      '<div class="bt-gauge-labels">' + labels + '</div></div>';
  }

  var COLORS = { blue: '#007AFF', green: '#34C759', orange: '#FF9F0A', red: '#FF3B30', gray: '#8E8E93', teal: '#64D2FF', lime: '#A8E063' };

  // ── Herramientas ───────────────────────────────────────────────────────
  var tools = {};

  /* 1RM: promedio de Epley, Brzycki y Lombardi. Con una sola repeticion el 1RM es el peso. */
  tools['1rm'] = {
    onChange: function (root, v) {
      root.querySelectorAll('[data-unit-label]').forEach(function (el) { el.textContent = v.unit; });
    },
    compute: function (v) {
      var lift = num(v.lift);
      var reps = Math.round(num(v.reps));
      if (!inRange(lift, 1, 1000) || !inRange(reps, 1, 20)) return null;
      var unit = v.unit === 'lb' ? 'lb' : 'kg';
      var epley = reps === 1 ? lift : lift * (1 + reps / 30);
      var brzycki = reps === 1 ? lift : lift * 36 / (37 - reps);
      var lombardi = lift * Math.pow(reps, 0.1);
      var oneRm = (epley + brzycki + lombardi) / 3;
      var step = unit === 'kg' ? 2.5 : 5;
      var table = [[100, '1'], [95, '2'], [93, '3'], [90, '4'], [87, '5'], [85, '6'], [83, '7'], [80, '8'], [77, '9'], [75, '10'], [70, '12'], [65, '15'], [60, '20']];

      var rows = table.map(function (r) {
        var use = r[0] >= 85 ? 'Fuerza' : r[0] >= 67 ? 'Hipertrofia' : 'Resistencia';
        var w = Math.round(oneRm * r[0] / 100 / step) * step;
        return '<tr' + (r[0] === 100 ? ' class="is-strong"' : '') + '><td>' + r[0] + ' %</td><td>' + r[1] + '</td><td>' + use + '</td><td>' + fmtTrim(w, 1) + ' ' + unit + '</td></tr>';
      }).join('');

      var html = stat('Tu 1RM estimado' + (v.lift_name ? ' en ' + esc(v.lift_name.toLowerCase()) : ''), fmt(oneRm, 1), unit,
        'Promedio de tres fórmulas con ' + fmtTrim(lift, 1) + ' ' + unit + ' × ' + reps + (reps === 1 ? ' repetición.' : ' repeticiones.'));
      html += kpis([kpi('Epley', fmt(epley, 1), unit), kpi('Brzycki', fmt(brzycki, 1), unit), kpi('Lombardi', fmt(lombardi, 1), unit)], true);
      if (reps > 10) html += note('Con más de 10 repeticiones las fórmulas se separan mucho. Para una estimación fina, haz una serie pesada de 3 a 6.', true);
      html += '<h3 class="bt-h3">Cargas por porcentaje</h3>';
      html += '<div class="bt-table-wrap"><table class="bt-table"><thead><tr><th>% 1RM</th><th>Reps</th><th>Enfoque</th><th>Peso</th></tr></thead><tbody>' + rows + '</tbody></table></div>';
      html += note('Pesos redondeados a ' + step + ' ' + unit + ' para que salgan con discos. No intentes tu 1RM real sin calentar ni sin alguien que te asista.');
      return html;
    }
  };

  /* Calorias: Mifflin-St Jeor × factor de actividad, ajustado por objetivo. */
  tools.calories = {
    compute: function (v) {
      var age = num(v.age), height = num(v.height), weight = num(v.weight);
      if (!inRange(age, 15, 90) || !inRange(height, 120, 230) || !inRange(weight, 35, 250)) return null;
      var act = num(v.activity) || 1.55;
      var goal = num(v.goal) || 0;
      var cutting = goal < 0;
      var bmr = 10 * weight + 6.25 * height - 5 * age + (v.sex === 'f' ? -161 : 5);
      var tdee = bmr * act;
      var target = Math.round(tdee * (1 + goal) / 10) * 10;
      var weekly = (target - tdee) * 7 / 7700;

      var gPerKg = { standard: cutting ? 2.0 : 1.8, 'high-protein': cutting ? 2.4 : 2.2, 'low-fat': cutting ? 2.0 : 1.8, keto: cutting ? 2.0 : 1.7 }[v.diet] || 1.8;
      var protein = Math.round(weight * gPerKg);
      var fat, carbs;
      if (v.diet === 'keto') {
        carbs = 30;
        fat = Math.round((target - protein * 4 - carbs * 4) / 9);
      } else {
        var fatShare = { standard: 0.27, 'high-protein': 0.25, 'low-fat': 0.18 }[v.diet] || 0.27;
        fat = Math.round(target * fatShare / 9);
        carbs = Math.round((target - protein * 4 - fat * 9) / 4);
      }
      if (carbs < 0) { carbs = 0; fat = Math.max(0, Math.round((target - protein * 4) / 9)); }
      if (fat < 0) fat = 0;

      var kP = protein * 4, kC = carbs * 4, kF = fat * 9, kT = kP + kC + kF || 1;
      var goalText = goal === 0 ? 'Para mantener tu peso.' :
        (cutting ? 'Para perder grasa: ' : 'Para ganar peso: ') + (weekly > 0 ? '+' : '−') + fmt(Math.abs(weekly), 2) + ' kg por semana, aprox.';

      var html = stat('Calorías al día', fmt(target), 'kcal', goalText);
      html += kpis([kpi('Metabolismo basal', fmt(bmr), 'kcal'), kpi('Mantenimiento', fmt(Math.round(tdee / 10) * 10), 'kcal')]);
      html += '<h3 class="bt-h3">Tus macros</h3>';
      html += '<div class="bt-stack" role="img" aria-label="Reparto de calorías por macro">' +
        '<span style="width:' + (kP / kT * 100) + '%;background:' + COLORS.blue + '"></span>' +
        '<span style="width:' + (kC / kT * 100) + '%;background:' + COLORS.green + '"></span>' +
        '<span style="width:' + (kF / kT * 100) + '%;background:' + COLORS.orange + '"></span></div>';
      html += kpis([
        kpi('Proteína', protein, 'g', COLORS.blue),
        kpi('Carbohidratos', carbs, 'g', COLORS.green),
        kpi('Grasa', fat, 'g', COLORS.orange)
      ], true);
      html += list([
        ['Proteína por kilo de peso', fmtTrim(gPerKg, 1) + ' g/kg'],
        ['Proteína en 4 comidas', Math.round(protein / 4) + ' g cada una']
      ]);
      if (target < bmr) {
        html += note('<strong>Ojo:</strong> quedas por debajo de tu metabolismo basal. Es sostenible pocas semanas; si notas cansancio o bajas de fuerza, sube a “sin prisa”.', true);
      } else if (v.diet === 'keto') {
        html += note('En keto los 30 g de carbohidratos son netos y salen de verduras. Los primeros días es normal bajar 1 a 2 kg de agua.');
      } else {
        html += note('Pésate 3 o 4 mañanas por semana y compara promedios. Si en 2 o 3 semanas no te mueves como esperabas, ajusta 100 a 150 kcal.');
      }
      return { html: html, extra: { goal: String(goal) } };
    }
  };

  /* Proteina diaria: rangos en g/kg de la ISSN y del consenso para adultos mayores. */
  tools.protein = {
    compute: function (v) {
      var weight = num(v.weight);
      if (!inRange(weight, 35, 250)) return null;
      var ranges = {
        health: [0.8, 1.2, 'para salud y poca actividad'],
        endurance: [1.2, 1.6, 'para deportes de resistencia'],
        muscle: [1.6, 2.2, 'para ganar músculo'],
        cut: [1.8, 2.4, 'para perder grasa conservando músculo'],
        recomp: [2.0, 2.4, 'para recomposición corporal'],
        senior: [1.2, 1.6, 'para conservar músculo después de los 60']
      };
      var r = ranges[v.goal] || ranges.muscle;
      var low = Math.round(weight * r[0]);
      var high = Math.round(weight * r[1]);
      var target = Math.round((low + high) / 2);
      var meals = clamp(Math.round(num(v.meals)) || 4, 1, 8);
      var perMeal = Math.round(target / meals);
      var minMeal = Math.round(weight * 0.4);
      var scoop = inRange(num(v.scoop), 5, 60) ? num(v.scoop) : 24;
      var scoopsSuggested = clamp(Math.round(target * 0.3 / scoop), 1, 3);

      var html = stat('Proteína al día', fmt(target), 'g', 'Rango de ' + low + ' a ' + high + ' g ' + r[2] + ' (' + fmtTrim(r[0], 1) + '–' + fmtTrim(r[1], 1) + ' g por kilo).');
      html += kpis([kpi('Por comida', perMeal, 'g'), kpi('Mínimo útil por comida', minMeal, 'g')]);
      if (perMeal < minMeal) html += note('Con ' + meals + ' comidas cada una queda corta. Junta la proteína en menos tomas para que cada una llegue a ' + minMeal + ' g.', true);
      html += '<h3 class="bt-h3">Así se ven ' + target + ' g</h3>';
      html += list([
        ['Pechuga de pollo cocida', fmt(target / 31 * 100) + ' g'],
        ['Huevos enteros', fmt(target / 6) + ' piezas'],
        ['Scoops de proteína (' + fmtTrim(scoop, 1) + ' g c/u)', fmtTrim(target / scoop, 1)]
      ]);
      html += note('<strong>Cómo llegar sin batallar:</strong> ' + scoopsSuggested + (scoopsSuggested === 1 ? ' scoop' : ' scoops') + ' al día (' + Math.round(scoopsSuggested * scoop) + ' g) y el resto de comida. El suplemento funciona mejor cubriendo un hueco que sustituyendo comidas.');
      return { html: html, extra: { goal: v.goal || 'muscle' } };
    }
  };

  /* Creatina: 3-5 g/dia de mantenimiento; carga de 0.3 g/kg/dia por 5 dias. */
  tools.creatine = {
    compute: function (v) {
      var weight = num(v.weight);
      if (!inRange(weight, 35, 250)) return null;
      var dose = weight < 60 ? 3 : weight < 80 ? 4 : 5;
      var loading = v.mode === 'loading';
      var loadDaily = Math.round(weight * 0.3);
      var loadDays = 5;
      var loadTake = Math.round(loadDaily / 4 * 2) / 2;

      var html;
      if (loading) {
        html = stat('Fase de carga', loadDaily, 'g al día', 'Durante ' + loadDays + ' días, repartidos en 4 tomas de ' + fmtTrim(loadTake, 1) + ' g. Después bajas a la dosis diaria.');
        html += kpis([kpi('Días 1 a 5', loadDaily, 'g/día'), kpi('Del día 6 en adelante', dose, 'g/día')]);
      } else {
        html = stat('Tu dosis diaria', dose, 'g', 'Todos los días, entrenes o no, a la hora que quieras. En 3 a 4 semanas tus músculos quedan saturados.');
      }

      var tub = num(v.tub);
      var price = num(v.price);
      if (inRange(tub, 50, 5000)) {
        var days;
        if (loading) {
          var left = tub - loadDaily * loadDays;
          days = left < 0 ? Math.floor(tub / loadDaily) : loadDays + Math.floor(left / dose);
        } else {
          days = Math.floor(tub / dose);
        }
        html += '<h3 class="bt-h3">Tu bote de ' + fmtTrim(tub, 0) + ' g</h3>';
        var items = [kpi('Te dura', days, days === 1 ? 'día' : 'días')];
        if (inRange(price, 1, 20000) && days > 0) {
          items.push(kpi('Costo por día', money(price / days)));
        } else {
          items.push(kpi('Equivale a', fmtTrim(days / 30, 1), 'meses'));
        }
        html += kpis(items);
        if (inRange(price, 1, 20000) && days > 0) {
          html += list([['Costo al mes', money(price / days * 30)], ['Costo por gramo', money(price / tub)]]);
        }
        if (loading && tub - loadDaily * loadDays < 0) {
          html += note('Este bote no alcanza para los 5 días de carga. Usa la dosis diaria o compra una presentación más grande.', true);
        }
      }
      html += note('Un scoop rasante de creatina monohidratada pesa cerca de 5 g. Toma suficiente agua: subir 1 a 2 kg las primeras semanas es agua dentro del músculo, no grasa.');
      return { html: html, extra: { mode: loading ? 'loading' : 'daily' } };
    }
  };

  /* Grasa corporal: formula de la Marina de EE. UU. (Hodgdon y Beckett), en centimetros. */
  tools.bodyfat = {
    onChange: function (root, v) {
      var female = v.sex === 'f';
      var hip = root.querySelector('[data-hip-field]');
      if (hip) hip.hidden = !female;
      var waist = root.querySelector('[data-waist-label]');
      if (waist) waist.textContent = female ? 'Cintura (parte más estrecha)' : 'Cintura (a la altura del ombligo)';
    },
    compute: function (v) {
      var female = v.sex === 'f';
      var h = num(v.height), w = num(v.weight), neck = num(v.neck), waist = num(v.waist), hip = num(v.hip);
      if (!inRange(h, 120, 230) || !inRange(w, 35, 250) || !inRange(neck, 20, 70) || !inRange(waist, 40, 200)) return null;
      if (female && !inRange(hip, 50, 200)) return null;
      var circ = female ? waist + hip - neck : waist - neck;
      if (circ <= 0) return null;
      var bf = female
        ? 495 / (1.29579 - 0.35004 * Math.log10(circ) + 0.221 * Math.log10(h)) - 450
        : 495 / (1.0324 - 0.19077 * Math.log10(circ) + 0.15456 * Math.log10(h)) - 450;
      bf = clamp(bf, 2, 60);
      var m = h / 100;
      var bmi = w / (m * m);
      var fatKg = w * bf / 100;
      var lean = w - fatKg;
      var ffmi = lean / (m * m) + 6.1 * (1.8 - m);

      var seg = female
        ? [[10, 14, COLORS.teal, 'Esencial'], [14, 21, COLORS.green, 'Atlética'], [21, 25, COLORS.lime, 'Fitness'], [25, 32, COLORS.orange, 'Promedio'], [32, 45, COLORS.red, 'Alta']]
        : [[2, 6, COLORS.teal, 'Esencial'], [6, 14, COLORS.green, 'Atlético'], [14, 18, COLORS.lime, 'Fitness'], [18, 25, COLORS.orange, 'Promedio'], [25, 40, COLORS.red, 'Alta']];
      var cat = seg[seg.length - 1];
      for (var i = 0; i < seg.length; i++) { if (bf < seg[i][1]) { cat = seg[i]; break; } }
      var catKind = cat[2] === COLORS.red ? 'bad' : cat[2] === COLORS.orange ? 'warn' : 'good';

      var bmiCat = bmi < 18.5 ? 'Bajo peso' : bmi < 25 ? 'Normal' : bmi < 30 ? 'Sobrepeso' : 'Obesidad';

      var html = stat('Grasa corporal', fmt(bf, 1), '%', badge(cat[3], catKind));
      html += gauge(seg, bf);
      html += kpis([
        kpi('Masa magra', fmt(lean, 1), 'kg'),
        kpi('Masa grasa', fmt(fatKg, 1), 'kg'),
        kpi('IMC · ' + bmiCat, fmt(bmi, 1)),
        kpi('FFMI normalizado', fmt(ffmi, 1))
      ]);
      if (bmi >= 25 && bf < (female ? 25 : 18)) {
        html += note('Tu IMC sale alto pero tu grasa no: el IMC no distingue músculo de grasa. Para quien entrena pesas, el porcentaje de grasa dice más.');
      } else {
        html += note('Mídete cada 2 a 4 semanas en las mismas condiciones. Importa más la tendencia que un número suelto: este método tiene un margen de ±3 a 4 puntos.');
      }
      return html;
    }
  };

  /* Hidratacion: 35 ml/kg de base + perdida por sudor segun duracion, intensidad y clima. */
  tools.water = {
    compute: function (v) {
      var weight = num(v.weight);
      if (!inRange(weight, 35, 250)) return null;
      var minutes = clamp(num(v.minutes) || 0, 0, 480);
      var sweatRate = { low: 0.5, mid: 0.8, high: 1.2 }[v.intensity] || 0.8;
      var climate = { mild: [1, 0], hot: [1.25, 0.3], humid: [1.4, 0.5] }[v.climate] || [1, 0];
      var base = weight * 0.035;
      var sweat = minutes / 60 * sweatRate * climate[0];
      var total = Math.round((base + sweat + climate[1]) * 10) / 10;
      var glasses = Math.round(total * 1000 / 250);

      var html = stat('Agua al día', fmtTrim(total, 1), 'litros', 'Unos ' + glasses + ' vasos de 250 ml. Cuenta agua, café, té y tu shake.');
      html += kpis([kpi('Base por tu peso', fmtTrim(Math.round(base * 10) / 10, 1), 'L'), kpi('Extra por entrenar y clima', fmtTrim(Math.round((sweat + climate[1]) * 10) / 10, 1), 'L')]);

      if (minutes > 0) {
        var before = Math.round(weight * 6 / 50) * 50;
        var during = clamp(Math.round(sweatRate * climate[0] * 0.75 / 3 * 1000 / 10) * 10, 120, 300);
        var after = Math.round(sweat * 0.75 * 1000 / 50) * 50;
        var start = timeToMinutes(v.time);
        var at = function (offset) { return isFinite(start) ? minutesToTime(start + offset) + ' · ' : ''; };
        html += '<h3 class="bt-h3">Alrededor de tu entrenamiento</h3>';
        html += list([
          [at(-150) + 'Dos a tres horas antes', before + ' ml'],
          [at(0) + 'Durante, cada 15 a 20 min', during + ' ml'],
          [at(minutes) + 'Al terminar, en la primera hora', Math.max(after, 250) + ' ml']
        ]);
      }
      var needsElectrolytes = minutes >= 90 || (minutes >= 60 && (v.intensity === 'high' || v.climate !== 'mild'));
      if (needsElectrolytes) {
        html += note('<strong>Agrega electrolitos.</strong> Con más de una hora sudando pierdes sodio, y reponer solo agua puede darte calambres o dolor de cabeza. Busca de 300 a 600 mg de sodio por hora. <a class="bt-link" href="/collections/hidratacion">Ver hidratación →</a>');
      } else {
        html += note('Una guía rápida: si tu orina es amarilla clara, vas bien. Si es oscura, te falta agua.');
      }
      return html;
    }
  };

  /* Cafeina: limite de 400 mg/dia (EFSA), dosis ergogenica de 3-6 mg/kg (ISSN), vida media ~5 h. */
  tools.caffeine = {
    compute: function (v) {
      var weight = num(v.weight);
      if (!inRange(weight, 35, 250)) return null;
      var preMg = (num(v.pre) || 0) * (num(v.pre_mg) || 0);
      var sources = [
        ['Pre-entreno', preMg],
        ['Café', (num(v.coffee) || 0) * 95],
        ['Bebidas energéticas', (num(v.energy) || 0) * 160],
        ['Refresco de cola', (num(v.cola) || 0) * 35],
        ['Otras fuentes', num(v.other) || 0]
      ];
      var total = sources.reduce(function (s, x) { return s + Math.max(0, x[1]); }, 0);
      var perfLow = Math.round(weight * 3 / 10) * 10;
      var perfHigh = Math.min(400, Math.round(weight * 6 / 10) * 10);
      var kind = total <= 300 ? 'good' : total <= 400 ? 'warn' : 'bad';
      var label = total <= 300 ? 'Dentro del rango' : total <= 400 ? 'Cerca del límite' : 'Arriba del límite';

      var html = stat('Cafeína en el día', fmt(total), 'mg', badge(label, kind) + ' &nbsp;El límite para un adulto sano es 400 mg.');
      html += gauge([[0, 300, COLORS.green, 'Normal'], [300, 400, COLORS.orange, 'Límite'], [400, 600, COLORS.red, 'Demasiado']], Math.min(total, 600));
      html += kpis([
        kpi('Tu pre-entreno', fmt(preMg), 'mg · ' + fmtTrim(preMg / weight, 1) + ' mg/kg'),
        kpi('Dosis útil para rendir', perfLow + '–' + perfHigh, 'mg')
      ]);
      var rows = sources.filter(function (s) { return s[1] > 0; }).map(function (s) { return [s[0], fmt(s[1]) + ' mg']; });
      if (rows.length) html += list(rows);

      var last = timeToMinutes(v.last);
      var sleep = timeToMinutes(v.sleep);
      if (isFinite(last) && isFinite(sleep)) {
        var gap = sleep - last;
        if (gap <= 0) gap += 1440;
        var lastDose = preMg > 0 ? preMg : total;
        var remaining = lastDose * Math.pow(0.5, gap / 60 / 5);
        var cutoff = minutesToTime(sleep - 8 * 60);
        html += '<h3 class="bt-h3">Tu sueño</h3>';
        html += list([
          ['Hora de corte recomendada', cutoff],
          ['Cafeína activa al dormir', '≈ ' + fmt(remaining) + ' mg']
        ]);
        if (gap < 8 * 60 && lastDose > 0) {
          html += note('Tu última dosis queda a ' + fmtTrim(gap / 60, 1) + ' h de dormir. Aunque te duermas, la cafeína recorta el sueño profundo. Si entrenas tarde, prueba un pre-entreno sin estimulantes. <a class="bt-link" href="/collections/non-stim-pre-workout">Ver sin estimulantes →</a>', true);
        }
      }
      if (preMg / weight > 6) {
        html += note('<strong>Tu pre-entreno pasa de 6 mg por kilo.</strong> Arriba de eso no rindes más, solo aumentan el nerviosismo y la taquicardia. Empieza con medio scoop.', true);
      } else if (total > 400) {
        html += note('Bájale con el café o las energéticas y deja la cafeína para el entrenamiento, que es donde sí suma.', true);
      }
      html += note('Si estás embarazada o lactando, el límite baja a 200 mg al día. Con hipertensión o arritmias, consulta a tu médico.');
      return { html: html, extra: { total_mg: Math.round(total) } };
    }
  };

  /* Precio por porcion: compara 2 o 3 productos. Guarda su propio estado, no usa <form>. */
  tools['serving-price'] = {
    mount: function (root, done) {
      var box = root.querySelector('[data-compare]');
      var results = root.querySelector('[data-results]');
      var emptyHtml = results.innerHTML;
      var items = [{}, {}];
      var letters = ['A', 'B', 'C'];

      function field(i, key, label, unit, attrs) {
        return '<label class="bt-field"><span class="bt-label">' + label + '</span><span class="bt-input">' +
          '<input class="apple-form-input" data-i="' + i + '" data-k="' + key + '" ' + attrs + ' value="' + esc(items[i][key] || '') + '">' +
          (unit ? '<span class="bt-input-unit">' + unit + '</span>' : '') + '</span></label>';
      }

      function draw() {
        box.innerHTML = items.map(function (it, i) {
          return '<div class="bt-compare-item" data-item="' + i + '">' +
            '<div class="bt-compare-head"><strong>Producto ' + letters[i] + '</strong>' +
            (items.length > 2 ? '<button type="button" class="bt-compare-remove" data-remove="' + i + '" aria-label="Quitar producto ' + letters[i] + '">×</button>' : '') + '</div>' +
            '<label class="bt-field"><span class="bt-label">Nombre (opcional)</span><input class="apple-form-input" style="font-size:16px" data-i="' + i + '" data-k="name" maxlength="60" placeholder="Ej. Whey 5 lb" value="' + esc(it.name || '') + '"></label>' +
            field(i, 'price', 'Precio', 'MXN', 'type="number" inputmode="decimal" min="1" placeholder="1299"') +
            field(i, 'servings', 'Porciones por envase', 'porc.', 'type="number" inputmode="decimal" min="1" placeholder="71"') +
            field(i, 'protein', 'Proteína por porción', 'g', 'type="number" inputmode="decimal" min="0" placeholder="24"') +
            '<div class="bt-compare-out" data-out></div></div>';
        }).join('') + (items.length < 3 ? '<button type="button" class="bt-compare-add" data-add>+ Agregar otro producto</button>' : '');
        update();
      }

      function update() {
        var rows = items.map(function (it, i) {
          var price = num(it.price), servings = num(it.servings), protein = num(it.protein);
          var ok = price > 0 && servings > 0;
          return {
            i: i,
            name: (it.name && it.name.trim()) || 'Producto ' + letters[i],
            ok: ok,
            perServing: ok ? price / servings : NaN,
            per25: ok && protein > 0 ? price / (servings * protein) * 25 : NaN
          };
        });
        var valid = rows.filter(function (r) { return r.ok; });
        var byProtein = valid.length >= 2 && valid.every(function (r) { return isFinite(r.per25); });
        var metric = byProtein ? 'per25' : 'perServing';
        var sorted = valid.slice().sort(function (a, b) { return a[metric] - b[metric]; });
        var best = sorted.length >= 2 ? sorted[0] : null;

        rows.forEach(function (r) {
          var el = box.querySelector('[data-item="' + r.i + '"]');
          if (!el) return;
          el.classList.toggle('is-best', !!best && best.i === r.i);
          var out = el.querySelector('[data-out]');
          if (!r.ok) { out.innerHTML = '<span class="bt-hint">Llena precio y porciones.</span>'; return; }
          out.innerHTML = '<div class="bt-kpi-label">Por porción</div><div class="bt-kpi-value">' + money(r.perServing) + '</div>' +
            (isFinite(r.per25) ? '<div class="bt-hint">' + money(r.per25) + ' por cada 25 g de proteína</div>' : '') +
            (best && best.i === r.i ? '<div>' + badge('Rinde más', 'good') + '</div>' : '');
        });

        if (!best) { results.innerHTML = emptyHtml; return; }
        var worst = sorted[sorted.length - 1];
        var saving = (1 - best[metric] / worst[metric]) * 100;
        var monthly = (worst.perServing - best.perServing) * 30;
        var html = stat('La que más rinde', '<span style="font-size:30px;letter-spacing:-0.02em">' + esc(best.name) + '</span>', '', byProtein
          ? 'Comparado por costo de cada 25 g de proteína, que es lo que realmente pagas.'
          : 'Comparado por costo de cada porción. Agrega la proteína por porción para compararlos por proteína.');
        html += kpis([
          kpi('Te ahorras', fmt(saving, 0), '% vs la más cara'),
          kpi('Con una porción diaria', monthly > 0 ? money(monthly) : '$0', 'al mes')
        ]);
        html += list(sorted.map(function (r, idx) {
          return [(idx + 1) + '. ' + esc(r.name), money(r[metric]) + (byProtein ? ' / 25 g' : ' / porción')];
        }));
        if (byProtein) html += note('Una porción más barata no siempre rinde más: si trae menos proteína, pagas más por cada gramo. Revisa también que la proteína venga de whey o caseína y no de aminoácidos agregados.');
        results.innerHTML = html;
        done();
      }

      box.addEventListener('input', function (e) {
        var t = e.target;
        if (!t.hasAttribute('data-k')) return;
        items[+t.getAttribute('data-i')][t.getAttribute('data-k')] = t.value;
        update();
      });
      box.addEventListener('click', function (e) {
        if (e.target.closest('[data-add]')) { items.push({}); draw(); var inputs = box.querySelectorAll('[data-item="' + (items.length - 1) + '"] input'); if (inputs[1]) inputs[1].focus(); }
        var rm = e.target.closest('[data-remove]');
        if (rm) { items.splice(+rm.getAttribute('data-remove'), 1); draw(); }
      });
      draw();
    }
  };

  /* Discos por lado: reparto codicioso con los discos que marque el usuario. */
  var PLATE_SETS = {
    kg: {
      bars: [[20, '20 kg · olímpica'], [15, '15 kg · olímpica de mujer'], [10, '10 kg · técnica'], [7, '7 kg · barra Z o corta'], [0, 'Sin barra (máquina)']],
      collars: [[0, 'Sin seguros'], [0.25, '0.25 kg c/u · clip de resorte'], [2.5, '2.5 kg c/u · de competencia']],
      plates: [25, 20, 15, 10, 5, 2.5, 1.25, 0.5],
      defaults: [25, 20, 15, 10, 5, 2.5, 1.25],
      style: { 25: [COLORS.red, 130, 22], 20: [COLORS.blue, 130, 20], 15: ['#FFCC00', 115, 18], 10: [COLORS.green, 100, 16], 5: ['#F2F2F7', 72, 14], 2.5: ['#1D1D1F', 58, 12], 1.25: ['#8E8E93', 46, 10], 0.5: ['#C7C7CC', 36, 8] }
    },
    lb: {
      bars: [[45, '45 lb · olímpica'], [35, '35 lb · olímpica de mujer'], [15, '15 lb · técnica'], [0, 'Sin barra (máquina)']],
      collars: [[0, 'Sin seguros'], [5, '5 lb c/u · de competencia']],
      plates: [55, 45, 35, 25, 10, 5, 2.5],
      defaults: [45, 35, 25, 10, 5, 2.5],
      style: { 55: [COLORS.red, 130, 22], 45: [COLORS.blue, 130, 20], 35: ['#FFCC00', 115, 18], 25: [COLORS.green, 100, 16], 10: ['#1D1D1F', 72, 13], 5: ['#8E8E93', 58, 11], 2.5: ['#C7C7CC', 46, 9] }
    }
  };

  function splitPlates(perSide, available) {
    var left = perSide;
    var used = [];
    available.forEach(function (p) {
      while (left + 1e-9 >= p) { used.push(p); left -= p; }
    });
    return { used: used, left: Math.round(left * 100) / 100 };
  }

  function platesText(used, unit) {
    if (!used.length) return 'Solo la barra';
    var counts = {};
    used.forEach(function (p) { counts[p] = (counts[p] || 0) + 1; });
    return Object.keys(counts).map(Number).sort(function (a, b) { return b - a; }).map(function (p) {
      return counts[p] + ' × ' + fmtTrim(p) + ' ' + unit;
    }).join(', ');
  }

  tools.plates = {
    currentUnit: null,
    onChange: function (root, v) {
      var unit = v.unit === 'lb' ? 'lb' : 'kg';
      root.querySelectorAll('[data-unit-label]').forEach(function (el) { el.textContent = unit; });
      if (this.currentUnit === unit) return;
      this.currentUnit = unit;
      var set = PLATE_SETS[unit];
      root.querySelector('[data-bar-select]').innerHTML = set.bars.map(function (b) { return '<option value="' + b[0] + '">' + b[1] + '</option>'; }).join('');
      root.querySelector('[data-collar-select]').innerHTML = set.collars.map(function (c) { return '<option value="' + c[0] + '">' + c[1] + '</option>'; }).join('');
      root.querySelector('[data-plate-checks]').innerHTML = set.plates.map(function (p) {
        return '<label class="bt-check"><input type="checkbox" name="plate" value="' + p + '"' + (set.defaults.indexOf(p) > -1 ? ' checked' : '') + '><span>' + fmtTrim(p) + ' ' + unit + '</span></label>';
      }).join('');
    },
    compute: function (v, root) {
      var unit = v.unit === 'lb' ? 'lb' : 'kg';
      var set = PLATE_SETS[unit];
      var target = num(v.target);
      if (!inRange(target, 1, 1000)) return null;
      var bar = num(v.bar) || 0;
      var collar = num(v.collars) || 0;
      var available = Array.prototype.slice.call(root.querySelectorAll('[name="plate"]:checked')).map(function (c) { return num(c.value); }).sort(function (a, b) { return b - a; });
      var fixed = bar + collar * 2;
      if (target < fixed) {
        return stat('Por lado', '0', unit, 'La barra y los seguros ya pesan ' + fmtTrim(fixed) + ' ' + unit + '. Elige un peso mayor o una barra más ligera.');
      }
      if (!available.length) return note('Marca al menos un disco de los que tienes.', true);
      var perSide = (target - fixed) / 2;
      var res = splitPlates(perSide, available);
      var achieved = fixed + (perSide - res.left) * 2;

      var plateHtml = res.used.map(function (p) {
        var s = set.style[p] || ['#8E8E93', 60, 12];
        var light = s[0] === '#F2F2F7' || s[0] === '#FFCC00' || s[0] === '#C7C7CC';
        return '<span class="bt-plate" style="height:' + s[1] + 'px;width:' + s[2] + 'px;background:' + s[0] + ';color:' + (light ? '#1D1D1F' : '#fff') + '" title="' + fmtTrim(p) + ' ' + unit + '">' + (s[2] >= 14 ? fmtTrim(p) : '') + '</span>';
      }).join('');

      var html = stat('Por lado', fmtTrim(perSide - res.left), unit, platesText(res.used, unit));
      html += '<div class="bt-barbell" role="img" aria-label="Discos de un lado: ' + esc(platesText(res.used, unit)) + '">' +
        '<span class="bt-barbell-shaft"></span><span class="bt-barbell-collar" style="height:44px"></span>' +
        '<span class="bt-barbell-plates">' + plateHtml + '</span>' +
        (collar > 0 ? '<span class="bt-barbell-collar"></span>' : '') + '<span class="bt-barbell-sleeve"></span></div>';
      html += kpis([kpi('Barra', fmtTrim(bar), unit), kpi('Seguros', fmtTrim(collar * 2), unit), kpi('Total cargado', fmtTrim(achieved), unit)], true);
      if (res.left > 0) {
        html += note('Con esos discos no llegas exacto: te faltan ' + fmtTrim(res.left) + ' ' + unit + ' por lado. El total más cercano abajo es ' + fmtTrim(achieved) + ' ' + unit + '.', true);
      }
      if (target >= fixed + 20) {
        html += '<h3 class="bt-h3">Calentamiento</h3>';
        html += list([[50, 5], [70, 3], [85, 1]].map(function (w) {
          var goal = Math.max(fixed, Math.round(target * w[0] / 100 / (unit === 'kg' ? 2.5 : 5)) * (unit === 'kg' ? 2.5 : 5));
          var r = splitPlates((goal - fixed) / 2, available);
          return [w[0] + ' % × ' + w[1] + ' · ' + fmtTrim(fixed + (goal - fixed - r.left * 2)) + ' ' + unit, platesText(r.used, unit)];
        }));
      }
      return html;
    }
  };

  /* Zonas de frecuencia cardiaca: FCmax de Tanaka (208 − 0.7 × edad), Karvonen si hay reposo. */
  tools['heart-rate'] = {
    compute: function (v) {
      var age = num(v.age);
      var measured = num(v.max);
      var hasMax = inRange(measured, 120, 230);
      if (!inRange(age, 12, 95) && !hasMax) return null;
      var hrMax = hasMax ? Math.round(measured) : Math.round(208 - 0.7 * age);
      var rest = num(v.rest);
      var karvonen = inRange(rest, 30, 110) && rest < hrMax - 40;
      var hr = function (pct) { return Math.round(karvonen ? rest + (hrMax - rest) * pct : hrMax * pct); };
      var zones = [
        [0.5, 0.6, 'Zona 1 · Recuperación', 'Calentar, enfriar y días de descanso activo.', COLORS.gray],
        [0.6, 0.7, 'Zona 2 · Base aeróbica', 'Donde más grasa usas como combustible. Puedes platicar.', COLORS.blue],
        [0.7, 0.8, 'Zona 3 · Aeróbica', 'Ritmo sostenido; hablar ya cuesta trabajo.', COLORS.green],
        [0.8, 0.9, 'Zona 4 · Umbral', 'Series intensas; solo frases cortas.', COLORS.orange],
        [0.9, 1.0, 'Zona 5 · Máxima', 'Sprints de segundos; no puedes hablar.', COLORS.red]
      ];
      var html = stat('Frecuencia máxima', hrMax, 'lpm', hasMax ? 'La que mediste tú.' : 'Estimada con la fórmula de Tanaka para ' + age + ' años.');
      html += '<div class="bt-stack" aria-hidden="true">' + zones.map(function (z) { return '<span style="width:20%;background:' + z[4] + '"></span>'; }).join('') + '</div>';
      html += '<div class="bt-table-wrap"><table class="bt-table"><thead><tr><th>Zona</th><th>Para qué</th><th>Pulso</th></tr></thead><tbody>' +
        zones.map(function (z) {
          return '<tr><td style="white-space:nowrap"><span class="bt-dot" style="background:' + z[4] + ';margin-right:6px"></span>' + z[2] + '</td><td style="color:var(--apple-text-secondary);font-size:13px">' + z[3] + '</td><td style="white-space:nowrap"><strong>' + hr(z[0]) + '–' + hr(z[1]) + '</strong></td></tr>';
        }).join('') + '</tbody></table></div>';
      html += note(karvonen
        ? 'Calculado con Karvonen usando tu pulso en reposo de ' + Math.round(rest) + ' lpm: las zonas se ajustan a tu condición física.'
        : 'Agrega tu pulso en reposo para afinar las zonas con el método de Karvonen.');
      html += note('Para bajar grasa y ganar resistencia, junta muchos minutos en zona 2. Las zonas 4 y 5 son para series cortas, una o dos veces por semana.');
      return html;
    }
  };

  /* Quiz de suplementos. */
  var REC = {
    creatine: { t: 'Creatina monohidratada', h: 'creatinas', why: 'El suplemento con más estudios detrás para ganar fuerza y músculo. Sirve en cualquier objetivo, también para perder grasa sin perder fuerza.', how: '3 a 5 g al día, todos los días, a la hora que quieras.' },
    whey: { t: 'Proteína whey', h: 'proteinas-1', why: 'La forma más fácil y barata de llegar a tu proteína diaria sin cocinar de más.', how: '1 scoop después de entrenar o para completar una comida baja en proteína.' },
    isolate: { t: 'Proteína aislada (isolate)', h: 'proteinas-1', why: 'El aislado de suero pasa por un filtrado que le quita casi toda la lactosa; suele caer bien aunque la leche no.', how: 'Busca “isolate” o “hidrolizada” en la etiqueta. 1 scoop al día para completar tu proteína.' },
    vegan: { t: 'Proteína vegetal', h: 'proteina-vegana', why: 'Mezclas de chícharo y arroz con un perfil de aminoácidos completo, sin nada de origen animal.', how: '1 a 2 scoops al día; junta chícharo y arroz para cubrir la leucina.' },
    gainer: { t: 'Ganador de peso', h: 'mass-gainer', why: 'Si te cuesta comer, un shake con 600 a 1,200 kcal suma calorías sin dejarte lleno para la siguiente comida.', how: '1 porción entre comidas. Si te cae pesada, empieza con media.' },
    pre: { t: 'Pre-entreno', h: 'pre-entenos-1', why: 'Cafeína, citrulina y beta-alanina en una toma: más energía, enfoque y bombeo en la sesión.', how: 'Medio scoop la primera vez, 20 a 30 min antes de entrenar. Nada después de las 4 pm.' },
    nonstim: { t: 'Pre-entreno sin estimulantes', h: 'non-stim-pre-workout', why: 'Bombeo y resistencia con citrulina y beta-alanina, sin cafeína: no te acelera y puedes entrenar de noche y dormir.', how: '1 scoop 30 min antes de entrenar.' },
    caffeine: { t: 'Cafeína en cápsulas', h: 'cafeina', why: 'Hace que el entrenamiento se sienta más fácil y sube un poco el gasto de energía. Barata y con dosis exacta.', how: '100 a 200 mg 30 a 60 min antes de entrenar, no después de las 3 pm.' },
    electrolytes: { t: 'Electrolitos', h: 'hidratacion', why: 'Reponen el sodio y el potasio que pierdes al sudar; evitan calambres y bajones en sesiones largas o con calor.', how: 'Disueltos en tu agua durante entrenamientos de más de una hora.' },
    beta: { t: 'Beta-alanina', h: 'beta-alanina', why: 'Retrasa la fatiga en esfuerzos de 1 a 4 minutos: series largas, HIIT, crossfit o sprints.', how: '3.2 a 6.4 g al día, todos los días. El hormigueo es normal y no hace daño.' },
    citrulline: { t: 'L-citrulina', h: 'l-citrulina', why: 'Mejora el flujo sanguíneo: más bombeo y algunas repeticiones extra en series pesadas.', how: '6 a 8 g 45 min antes de entrenar.' },
    eaa: { t: 'Aminoácidos esenciales (EAA)', h: 'eaa', why: 'Útiles si entrenas en ayunas, entrenas diario o te cuesta llegar a tu proteína.', how: '1 porción durante o después de entrenar.' },
    multi: { t: 'Multivitamínico', h: 'vitaminas-y-complementos', why: 'Un seguro barato para cubrir huecos de vitaminas y minerales, sobre todo si comes menos para bajar de peso.', how: '1 porción al día con una comida.' },
    collagen: { t: 'Colágeno', h: 'colageno', why: 'Apoya tendones, ligamentos y articulaciones, que se cargan más con los años y con el peso.', how: '10 a 15 g al día, idealmente con vitamina C, una hora antes de entrenar.' },
    joints: { t: 'Fórmula para articulaciones', h: 'articulaciones', why: 'Glucosamina, condroitina y MSM para rodillas, hombros y codos que ya se quejan.', how: 'Todos los días; se nota a partir de 4 a 8 semanas.' },
    sleep: { t: 'Apoyo para dormir', h: 'sueno', why: 'Magnesio, melatonina o ashwagandha según la fórmula. Dormir bien es la mitad de tu recuperación.', how: '30 a 60 min antes de dormir.' },
    probiotics: { t: 'Probióticos', h: 'probioticos', why: 'Ayudan a tu flora intestinal cuando comes mucha proteína o cambias de dieta.', how: '1 cápsula al día, de preferencia en ayunas.' },
    enzymes: { t: 'Enzimas digestivas', h: 'enzimas', why: 'Si los shakes o las comidas grandes te inflaman, ayudan a digerir proteína y grasa.', how: 'Con tus comidas más pesadas.' },
    carnitine: { t: 'L-carnitina', h: 'l-carnitina', why: 'Participa en el uso de grasa como energía. La evidencia es modesta: suma solo si ya tienes dieta y entrenamiento en orden.', how: '1 a 2 g al día con una comida.' }
  };

  var QUESTIONS = [
    { id: 'goal', q: '¿Cuál es tu objetivo principal?', o: [
      ['muscle', '💪', 'Ganar músculo'], ['gain', '🍽️', 'Subir de peso', 'Me cuesta comer'], ['fat', '🔥', 'Perder grasa'],
      ['strength', '🏋️', 'Más fuerza y rendimiento'], ['endurance', '🏃', 'Resistencia y cardio'], ['health', '🌿', 'Salud y bienestar']] },
    { id: 'freq', q: '¿Cuántos días a la semana entrenas?', o: [
      ['0', '🌱', 'Estoy empezando', '0 a 1 día'], ['2', '📅', '2 a 3 días'], ['4', '🔁', '4 a 5 días'], ['6', '🔥', '6 o más días']] },
    { id: 'diet', q: '¿Cómo es tu alimentación?', o: [
      ['omni', '🍗', 'Como de todo'], ['vegetarian', '🥚', 'Vegetariana'], ['vegan', '🌱', 'Vegana'], ['lactose', '🥛', 'Me cae mal la lactosa']] },
    { id: 'stim', q: '¿Cómo te llevas con la cafeína?', o: [
      ['ok', '☕', 'Bien', 'Tomo café o pre sin problema'], ['sensitive', '😵', 'Me acelera', 'Me pone nervioso o no duermo'], ['none', '🚫', 'Prefiero cero estimulantes']] },
    { id: 'focus', q: '¿Qué más te gustaría mejorar?', o: [
      ['energy', '⚡', 'Energía en el gym'], ['recovery', '🧊', 'Recuperación', 'Dolor muscular que no se va'], ['joints', '🦴', 'Articulaciones'],
      ['sleep', '😴', 'Dormir mejor'], ['digestion', '🫧', 'Digestión'], ['none', '✅', 'Nada más']] },
    { id: 'age', q: '¿Qué edad tienes?', o: [
      ['18', '🧑', 'Menos de 25'], ['25', '🧑‍💼', '25 a 39'], ['40', '🧔', '40 a 54'], ['55', '🧓', '55 o más']] },
    { id: 'budget', q: '¿Cuánto quieres invertir al mes?', o: [
      ['low', '💵', 'Hasta $700', 'Solo lo esencial'], ['mid', '💳', '$700 a $1,500'], ['high', '💎', 'Más de $1,500', 'Quiero el stack completo']] }
  ];

  function recommend(a) {
    var score = {};
    function add(k, n) { score[k] = Math.max(score[k] || 0, 0) + n; }
    var goals = {
      muscle: { whey: 100, creatine: 95, pre: 45 },
      gain: { gainer: 100, creatine: 95, whey: 60 },
      fat: { whey: 100, creatine: 80, caffeine: 70, multi: 50, carnitine: 35 },
      strength: { creatine: 100, pre: 80, whey: 75, beta: 55, citrulline: 45 },
      endurance: { electrolytes: 100, beta: 70, whey: 60, caffeine: 60, creatine: 50 },
      health: { multi: 100, whey: 70, creatine: 65, collagen: 50, probiotics: 40 }
    }[a.goal] || {};
    // Los dos pilares del objetivo llevan un extra para que una molestia o la edad no los
    // saquen del top: quien busca fuerza tiene que ver la creatina antes que el colageno.
    Object.keys(goals).forEach(function (k, i) { add(k, goals[k] + (i < 2 ? 40 : 0)); });

    if (a.freq === '0') { add('pre', -40); add('beta', -30); add('eaa', -20); }
    if (a.freq === '4') { add('eaa', 30); }
    if (a.freq === '6') { add('eaa', 45); add('electrolytes', 40); }

    if (a.focus === 'energy') { add('pre', 35); add('multi', 20); }
    if (a.focus === 'recovery') { add('eaa', 55); add('sleep', 30); }
    if (a.focus === 'joints') { add('collagen', 60); add('joints', 45); }
    if (a.focus === 'sleep') { add('sleep', 65); add('caffeine', -100); }
    if (a.focus === 'digestion') { add('probiotics', 60); add('enzymes', 40); }

    if (a.age === '40') { add('collagen', 25); add('joints', 20); add('multi', 15); }
    if (a.age === '55') { add('creatine', 15); add('whey', 20); add('joints', 35); add('multi', 25); add('pre', -30); }

    // Estimulantes: se cambian por la version sin cafeina, no se descartan.
    var noStim = a.stim !== 'ok' || a.focus === 'sleep';
    if (noStim) {
      if (score.pre) { add('nonstim', score.pre); delete score.pre; }
      delete score.caffeine;
    }

    // Dieta: la whey se cambia por la opcion que si le cae o que es vegetal.
    if (a.diet === 'vegan' || a.diet === 'lactose') {
      var alt = a.diet === 'vegan' ? 'vegan' : 'isolate';
      if (score.whey) { add(alt, score.whey); delete score.whey; }
    }
    if (a.diet === 'vegan' || a.diet === 'vegetarian') {
      if (score.collagen) { add('joints', score.collagen); delete score.collagen; }
    }
    if (a.diet === 'vegan' && score.gainer) { add('vegan', score.gainer); delete score.gainer; }

    var limit = { low: 2, mid: 3, high: 5 }[a.budget] || 3;
    return Object.keys(score)
      .filter(function (k) { return score[k] > 25 && REC[k]; })
      .sort(function (x, y) { return score[y] - score[x]; })
      .slice(0, limit);
  }

  var productCache = {};
  function loadProducts(handle, cheapFirst) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=24')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return d.products || []; })
        .catch(function () { return []; });
    }
    return productCache[handle].then(function (products) {
      var usable = products.filter(function (p) {
        return p.images && p.images.length && p.variants && p.variants.some(function (x) { return x.available; });
      });
      if (cheapFirst) usable.sort(function (x, y) { return num(x.variants[0].price) - num(y.variants[0].price); });
      return usable.slice(0, 3);
    });
  }

  function sizedImage(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  tools.quiz = {
    mount: function (root, done) {
      var box = root.querySelector('[data-quiz]');
      var step = 0;
      var answers = {};
      var lastPct = 0;

      function drawQuestion() {
        var q = QUESTIONS[step];
        box.innerHTML =
          '<div class="bt-progress" aria-hidden="true"><span style="width:' + (step / QUESTIONS.length * 100) + '%"></span></div>' +
          '<div class="bt-step-count">Pregunta ' + (step + 1) + ' de ' + QUESTIONS.length + '</div>' +
          '<h2 class="bt-question" tabindex="-1">' + q.q + '</h2>' +
          '<div class="bt-options" role="group" aria-label="' + esc(q.q) + '">' + q.o.map(function (o) {
            return '<button type="button" class="bt-option' + (answers[q.id] === o[0] ? ' is-selected' : '') + '" data-value="' + o[0] + '" aria-pressed="' + (answers[q.id] === o[0]) + '">' +
              '<span class="bt-option-icon" aria-hidden="true">' + o[1] + '</span><span>' + o[2] + (o[3] ? '<small>' + o[3] + '</small>' : '') + '</span></button>';
          }).join('') + '</div>' +
          '<div class="bt-quiz-nav">' +
          (step > 0 ? '<button type="button" class="bt-btn bt-btn--ghost" data-back>← Atrás</button>' : '<span></span>') +
          '<span class="bt-hint">Toma menos de un minuto</span></div>';
        // La barra nace con el ancho del paso anterior y se anima al nuevo.
        var pct = step / QUESTIONS.length * 100;
        var bar = box.querySelector('.bt-progress span');
        bar.style.width = lastPct + '%';
        requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.width = pct + '%'; }); });
        lastPct = pct;
      }

      function drawResult() {
        var keys = recommend(answers);
        var cheap = answers.budget === 'low';
        var goalLabel = QUESTIONS[0].o.filter(function (o) { return o[0] === answers.goal; })[0];
        box.innerHTML =
          '<div class="bt-progress" aria-hidden="true"><span style="width:100%"></span></div>' +
          '<div class="bt-step-count">Tu resultado</div>' +
          '<h2 class="bt-question" tabindex="-1">Tu stack para ' + (goalLabel ? esc(goalLabel[2].toLowerCase()) : 'empezar') + '</h2>' +
          '<p class="bt-subhead" style="font-size:15px;margin-bottom:18px">Ordenado por lo que más te va a servir. Los ' + Math.min(2, keys.length) + ' primeros son la base; lo demás suma si tu presupuesto lo permite.</p>' +
          '<div class="bt-stack-list">' + keys.map(function (k, i) {
            var r = REC[k];
            return '<article class="bt-rec">' +
              '<div class="bt-rec-head"><span class="bt-rec-num">' + (i + 1) + '</span><div>' +
              '<h3 class="bt-rec-title">' + r.t + ' ' + (i < 2 ? badge('Base', 'info') : badge('Suma', 'good')) + '</h3>' +
              '<p>' + r.why + '</p><p class="bt-rec-how"><strong>Cómo tomarlo:</strong> ' + r.how + '</p></div></div>' +
              '<div class="bt-rec-products" data-products="' + r.h + '"></div>' +
              '<a class="bt-link" href="/collections/' + r.h + '">Ver todas las opciones →</a></article>';
          }).join('') + '</div>' +
          '<div class="bt-actions"><button type="button" class="bt-btn bt-btn--ghost" data-restart>Volver a empezar</button>' +
          '<a class="bt-btn bt-btn--primary" href="/pages/calculadora-de-calorias-y-macros">Calcula tus calorías →</a></div>';

        box.querySelectorAll('[data-products]').forEach(function (slot) {
          loadProducts(slot.getAttribute('data-products'), cheap).then(function (products) {
            if (!products.length) { slot.remove(); return; }
            slot.innerHTML = products.map(function (p) {
              var variant = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
              return '<a class="bt-mini" href="/products/' + encodeURIComponent(p.handle) + '">' +
                '<img src="' + esc(sizedImage(p.images[0].src, 240)) + '" alt="' + esc(p.title) + '" loading="lazy" width="120" height="120">' +
                '<span class="bt-mini-title">' + esc(p.title) + '</span>' +
                '<span class="bt-mini-price">' + money(num(variant.price)) + '</span></a>';
            }).join('');
          });
        });
        done({ goal: answers.goal || '', budget: answers.budget || '' });
      }

      function focusTop() {
        var h = box.querySelector('.bt-question');
        if (h) h.focus({ preventScroll: true });
        var top = box.getBoundingClientRect().top + window.pageYOffset - 100;
        if (box.getBoundingClientRect().top < 80) window.scrollTo({ top: top, behavior: 'smooth' });
      }

      box.addEventListener('click', function (e) {
        var opt = e.target.closest('.bt-option');
        if (opt) {
          answers[QUESTIONS[step].id] = opt.getAttribute('data-value');
          box.querySelectorAll('.bt-option').forEach(function (b) {
            var on = b === opt;
            b.classList.toggle('is-selected', on);
            b.setAttribute('aria-pressed', on);
          });
          setTimeout(function () {
            step += 1;
            if (step >= QUESTIONS.length) drawResult(); else drawQuestion();
            focusTop();
          }, 180);
          return;
        }
        if (e.target.closest('[data-back]')) { step = Math.max(0, step - 1); drawQuestion(); focusTop(); return; }
        if (e.target.closest('[data-restart]')) { step = 0; answers = {}; drawQuestion(); focusTop(); }
      });

      drawQuestion();
    }
  };

  // ── Montaje ────────────────────────────────────────────────────────────
  function mountForm(root, name, tool) {
    var form = root.querySelector('[data-form]');
    var results = root.querySelector('[data-results]');
    if (!form || !results) return;
    var emptyHtml = results.innerHTML;
    applyProfile(form);

    function run() {
      var values = formValues(form);
      if (tool.onChange) tool.onChange(root, values);
      var out;
      try { out = tool.compute(formValues(form), root); } catch (e) { out = null; }
      if (!out) { results.innerHTML = emptyHtml; return; }
      var html = typeof out === 'string' ? out : out.html;
      results.innerHTML = html;
      track(name, typeof out === 'string' ? null : out.extra);
    }

    var timer;
    form.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 120); });
    form.addEventListener('change', function () { clearTimeout(timer); saveProfile(form); run(); });
    form.addEventListener('focusout', function () { saveProfile(form); });
    run();
  }

  function init() {
    document.querySelectorAll('[data-tool]').forEach(function (root) {
      if (root.__btMounted) return;
      root.__btMounted = true;
      var name = root.getAttribute('data-tool');
      var tool = tools[name];
      if (!tool) return;
      if (tool.mount) {
        tool.mount(root, function (extra) { track(name, extra); });
      } else {
        mountForm(root, name, tool);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Editor de temas: al cambiar un ajuste la seccion se vuelve a pintar.
  document.addEventListener('shopify:section:load', init);
})();
